import { Link, Navigate, useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback, useMemo, useContext } from "react"
import axios from "axios";
import { CSVLink } from "react-csv";
import { useDropzone } from "react-dropzone";
import Papa from 'papaparse';
import Encoding from "encoding-japanese";
import { API, MSG } from "./constantsFront";
import { MsgContext } from '../../App';

const G010QuarantineList = () => {

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  const navigate = useNavigate();

  let body = { authKey: API.API_KEY };

  const baseStyle = {
    display: "flex",
    flexDirection: "column",
    width: 200,
    height: 150,
  };
  const borderNormalStyle = {
    border: "1px dotted #888"
  };
  const borderDragStyle = {
    border: "1px solid #00f",
    transition: 'border .5s ease-in-out'
  };

  const csvData = [
    ["firstname", "lastname", "email"],
    ["Ahmed", "Tomi", "ah@smthing.co.com"],
    ["Raed", "Labes", "rl@smthing.co.com"],
    ["Yezzi", "Min l3b", "ymin@cocococo.com"]
  ];

  const [selectedFile, setSelectedFile] = useState();

  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFile(acceptedFiles[0]);
  }, []);
  const { getRootProps, getInputProps, isDragActive, open, acceptedFiles } = useDropzone({
    accept: {
      'text/csv': [],
    },
    multiple: false,
    onDrop,
    noClick: true
  });
  const style = useMemo(() => (
    { ...baseStyle, ...(isDragActive ? borderDragStyle : borderNormalStyle) }
  ), [isDragActive]);
  const files = useMemo(() =>
    acceptedFiles.map((file) => (
      <li key={file.path}>
        {file.path} - {file.size} bytes
      </li>
    )
    ), [acceptedFiles]);

  // const changeHandler = (event) => {
  // 	setSelectedFile(event.target.files[0]);
  // };

  const handleFiles = files => {
    try {
      let file_type = selectedFile.name.split('.').pop();
      if (file_type != "csv" || selectedFile == null) {
        console.log(selectedFile.name);
        return alert("CSVファイルを選択してください");
      }

      let reader = new FileReader();
      // reader.readAsText(files[0]);
      //reader.readAsText(selectedFile);
      reader.readAsArrayBuffer(selectedFile);

      reader.onload = async function (e) {
        let uniqueList = [];
        let csletr = [];

        const codes = new Uint8Array(e.target.result);
        const encoding = Encoding.detect(codes);
        const unicodeString = Encoding.convert(codes, {
          to: 'unicode',
          from: encoding,
          type: 'string',
        });

        console.log(unicodeString)

        // 改行ごとに配列化
        let lines = unicodeString.split(/\r\n|\n/);

        // 表示
        console.log(lines);

        // 1行ごとに処理
        for (let i = 0; i < lines.length; ++i) {
          //現在の行数
          let row = Number(i) + 1;

          //カンマとダブルクォーテーションのエスケープ
          let cells = lines[i].split(',').reduce(([data, isInQuotes], text) => {
            if (isInQuotes) {
              data[data.length - 1] += ',' + text.replace(/\"+/g, m => '"'.repeat(m.length / 2))
              return [data, !(text.match(/\"*$/)[0].length % 2)]
            } else {
              const match = text.match(/^(\"?)((.*?)(\"*))$/)
              data.push(match[1] ? match[2].replace(/\"+/g, m => '"'.repeat(m.length / 2)) : match[2])
              return [data, match[1] && !(match[4].length % 2)]
            }
          }, [[]])[0];
          console.log(cells);

          //CSVの中身が正しい場合
          if (cells.length == 4) {
            if (i == 0) {
              //ヘッダーの内容が違う場合
              if (cells[0] != "輸出相手国コード") {
                console.log(cells[0]);
                return alert("選択したファイルの型式が違います。");
              }
              continue;
            }

            //同じ輸出相手国コードが存在する場合
            if (uniqueList.indexOf(cells[0]) != -1) {
              return alert((uniqueList.indexOf(cells[0]) + 2) + "行目と同じ「輸出相手国コード」が" + row + "行目に存在します。");
            }
            uniqueList.push(cells[0]);
            // const responce = await axios.get(`/m_export_country/select?name=${cells[0]}`);
            // //既にデータが存在する場合
            // if(responce.data.dataList.length != 0){
            //   return alert("既にデータが存在します。");
            // }
            csletr.push(cells);
          } else {
            return alert("選択したファイルの型式が違います。");
          }
        }

        // 表示
        // for(let i in csletr){
        //   //var arrStr = encodeURIComponent(JSON.stringify(csletr[i]));
        //   var arrStr = JSON.stringify(csletr[i]);
        //   //const obj = JSON.parse(arrStr);
        //   console.log(arrStr);
        //   //fetch(`/m_export_country/upload/auth?dataListJson=${arrStr}`,{method: "POST"});
        //   await axios.post(`/m_export_country/upload/auth?dataListJson=${arrStr}`);
        // }

        //var arrStr = encodeURIComponent(JSON.stringify(csletr));
        let arrStr = JSON.stringify(csletr);
        //const obj = JSON.parse(arrStr);
        console.log(arrStr);
        //fetch(`/m_export_country/upload/auth?dataListJson=${arrStr}`,{method: "POST"});
        body.arrStr = arrStr
        const res = await axios.post("/m_export_country/upload/auth", body);
        if (res.status === 200) {
          return alert('Upload complete');
        }
      }
    } catch (err) {
      return new Error(err.message);
    }
  }

  return (
    <>
      <h1>検疫情報一覧</h1>
      <div className="container">
        <div {...getRootProps({ style })}>
          {/* <input {...getInputProps()} /> */}
          {/* <input type="file" name="file" accept="text/csv" onChange={changeHandler} /> */}
          <p className="">ここにファイルをドラッグ<br />または</p>
          <button type="button" onClick={open} className="">ファイルを選択</button>
        </div>
        <aside className="mt-1">
          <h4 className="mb-0">Files</h4>
          <ul>{files}</ul>
        </aside>
        <div>
          <button onClick={handleFiles}>保存</button>
        </div>
      </div>

      <CSVLink data={csvData}>Download</CSVLink>

    </>
  );
};

export default G010QuarantineList;